<template>
  <div v-if="alert.status === 'success'">
    <Alert class="mt-2" status="success">
      {{ alert.message }}
    </Alert>
  </div>
  <FormContainer v-else @submitForm="reserve">
    <div class="row">
      <div v-if="availableRoles.length === 1" class="col-12 col-md-6 col-lg-4 mb-2">
        Ruolo:
        <strong>
        {{availableRoles[0].label}}
        </strong>
      </div>
      <FormInputSelectWidget
        class="col-12 col-md-6 col-lg-4"
        label="Ruolo"
        v-model="user.role"
        v-else-if="showRoles && availableRoles.length >= 1"
        :errorMsg="errorHash.role"
        :options="availableRoles"
        optionValue="name"
        @input="removeError('role')"
      />
      <FormInputTextWidget
        class="col-12"
        label="Email"
        placeholder="example@email.com"
        v-model="user.email"
        :errorMsg="errorHash.email"
        type="email"
        @input="removeError('email')"
      />
      <FormInputIntegerWidget
        v-if="role === 'consultant'"
        class="col-lg-4 col-sm-6 mt-2"
        label="Aziende creabili"
        v-model.number="companiesAdd"
        min="0"
        :disabled="infiniteCompanies"
        :errorMsg="errorHash['companiesAdd']"
        @input="removeError('companiesAdd')"
      />
      <div class="col-lg-8 col-sm-6 d-flex align-items-center mt-2" v-if="role === 'consultant'">
        <BFormCheckbox
          v-model="infiniteCompanies"
          name="infiniteCompanies"
          switch
        >
        Aziende creabili illimitate
        </BFormCheckbox>
      </div>
        <div class="col-12 d-flex align-items-center mt-3" v-if="role === 'consultant'">
            <BFormCheckbox
              v-model="user.canInviteUsers"
              name="canInviteUsers"
              switch
            >
            Può invitare utenti
            </BFormCheckbox>
        </div>

        <div class="col-12 d-flex align-items-center mt-2" v-if="role === 'consultant'">
            <BFormCheckbox
              v-model="user.canEditModules"
              name="canEditModules"
              switch
            >
            Può gestire i moduli
            </BFormCheckbox>
      </div>
    </div>
    <div class="pt-5 text-right">
      <button class="btn btn-primary" type="submit">Invita</button>
    </div>
  </FormContainer>
</template>

<script>

import { availableRoles } from '@/filters/formatRoles';
import { BFormCheckbox } from 'bootstrap-vue';
import validateMixin from '../../../libs/Form/mixins/validate';
import uploadFilesMixin from '../../../libs/Uploader/mixins/uploadFiles';

export default {
  name: 'profile-reservation-form',
  mixins: [validateMixin, uploadFilesMixin],
  components: {
    FormContainer: () => import('../../../libs/Form/components/FormContainer'),
    Alert: () => import('../../../libs/Feedback/components/Alert'),
    BFormCheckbox,
    FormInputTextWidget: () => import('../../../libs/Form/components/Inputs/Widgets/FormInputTextWidget'),
    FormInputSelectWidget: () => import('../../../libs/Form/components/Inputs/Widgets/FormInputSelectWidget'),
    FormInputIntegerWidget: () => import('@/libs/Form/components/Inputs/Widgets/FormInputIntegerWidget'),
  },
  props: {
    role: {
      type: String,
      default: null,
      validator: function (role) {
        return availableRoles.map(ar => ar.name).indexOf(role) >= 0;
      },
    },
    roles: {
      type: Array,
      default: () => availableRoles.map(role => role.name),
      validator: function (roles) {
        return !roles.find(role => {
          return availableRoles.map(ar => ar.name).indexOf(role) < 0;
        });
      },
    },
    user: {
      type: Object,
      default: () => ({
        email: null,
        role: null,
        company: null,
        maxCompaniesAllowed: null,
        canInviteUsers: true,
        canEditModules: true,
      }),
    },
  },
  data () {
    return {
      alert: {
        status: null,
        message: null,
      },
      showRoles: true,
      companiesAdd: null,
      infiniteCompanies: true,
    };
  },
  computed: {
    availableRoles () {
      const roles = this.roles.map(role => {
        return availableRoles.find(arole => arole.name === role);
      });

      return roles;
    },
  },
  methods: {
    reserve () {
      if (this.infiniteCompanies) {
        this.user.maxCompaniesAllowed = null;
      } else {
        this.user.maxCompaniesAllowed = this.companiesAdd;
      }

      if (this.availableRoles.length === 1) {
        this.user.role = this.availableRoles[0].name;
      }
      if (!this.isValid()) {
        return;
      }

      this.$api.reserveUser(this.user).then(res => {
        this.user.role = null;
        this.user.email = null;
        this.$emit('success', res);
      }).catch(err => {
        this.$log.debug(err);
        this.$emit('error', err);
      });
    },
    isValid () {
      this.clearErrors();

      this.$log.debug(this.user);

      // email
      if (!this.validateEmail(this.user.email)) {
        this.addError('L\'email che hai inserito non è valida', 'email');
      }

      // role
      if (!this.user.role) {
        this.addError('Devi scegliere un ruolo', 'role');
      }

      return !this.hasErrors;
    },
    validateEmail (email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    resetFeedBack () {
      this.alert.status = null;
      this.alert.message = null;
    },
  },
  mounted () {
    if (this.role) {
      this.user.role = this.role;
      this.showRoles = false;
    }
  },
};

</script>

<style lang="scss"></style>
